import React from 'react'
import {components} from 'react-select'

const DropdownIndicator = (props) =>
    components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
            <span className="material-icons">expand_more</span>
        </components.DropdownIndicator>
    )

export default DropdownIndicator
